<template>
  <div class="background-image-login">
    <div class="login-system-title">
      <img class="logo-icon" src="../assets/images/logo-icon-sdhz.png">大都会展数智平台
    </div>
    <div class="login-container">
      <div class="login-form">
        <!-- 登录表单 -->
        <el-form ref="loginForm" :model="loginForm" :rules="rules">
          <div class="title">
            <h2>账号密码登录</h2>
          </div>
          <!-- 用户名输入框 -->
          <el-form-item label="" prop="username">
            <el-input
                v-model="loginForm.username"
                prefix-icon="el-icon-user"
                placeholder="请输入用户名">
            </el-input>
          </el-form-item>
          <!-- 密码输入框 -->
          <el-form-item label="" prop="password">
            <el-input
                type="password"
                v-model="loginForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码">
            </el-input>
          </el-form-item>
<!--          <el-form-item label="" prop="captcha">
            <el-input v-model="loginForm.captcha" placeholder="请输入验证码" autocomplete="off"></el-input>
          </el-form-item>-->
          <el-form-item>
            <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
          </el-form-item>
          <!-- 登录按钮 -->
          <el-form-item>
            <el-button type="primary" @click="handleLogin">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
<!--    <div class="footer">版权所有 Copyright © 2023-2025 北京融亦投智能科技有限公司</div>-->
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import userApi from '../api/user.js'
import { mapActions } from 'vuex';

export default {
  name: "Login",
  data() {
    return {
      // 登录表单数据
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        remember: false,
      },
      tokenApplition: null,
      rules:{
        username: [{required: true, message: '请输入用户名', trigger: 'change'}],
        password: [{required: true, message: '请输入密码', trigger: 'change'}],
        /*captcha: [{required: true, message: '请输入验证码', trigger: 'change'}],*/
      }
    }
  },
  mounted() {
    const users = JSON.parse(localStorage.getItem('users')) || [];
    if (users.length > 0) {
      // 假设自动填充最后一个用户信息，实际应用中可能需要用户选择
      const lastUser = users[users.length - 1];
      const decryptedPassword = CryptoJS.AES.decrypt(lastUser.password, 'secretkey123').toString(CryptoJS.enc.Utf8);
      this.loginForm.username = lastUser.username;
      this.loginForm.password = decryptedPassword;
      this.loginForm.remember = true;
    }
  },
  methods: {
    ...mapActions(['loginUser','loginCheckedMenu']),  // 将action映射到组件的methods中
    // 处理登录逻辑
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let users = JSON.parse(localStorage.getItem('users')) || [];
          if (this.loginForm.remember) {
            const encryptedPassword = CryptoJS.AES.encrypt(this.loginForm.password, 'secretkey123').toString();
            const userIndex = users.findIndex(user => user.username === this.loginForm.username);
            if (userIndex !== -1) {
              users[userIndex].password = encryptedPassword;
            } else {
              users.push({username: this.loginForm.username, password: encryptedPassword});
            }
            localStorage.setItem('users', JSON.stringify(users));
          } else {
            const usersNew = users.filter(user => user.username !== this.loginForm.username);
            localStorage.setItem('users', JSON.stringify(usersNew));
          }
          // 在这里添加登录验证逻辑
          this.loading = true
          userApi.login({
            username: this.loginForm.username,
            password: this.loginForm.password,
            // verification_code: this.loginForm.checkCode,
            // grant_type: "password",
            //client_id: "authClient",
            //scope: "all",
            //client_secret: "authSecret",
          }).then((res) => {
            if (res.msg) {
              this.$message.error(res.msg)
            } else {
              this.tokenApplition = res.token
              localStorage.setItem("token", res.token)
              this.getUserInfo()
            }
            setTimeout(() => {
              this.loading = false
            }, 1000)

          }).catch((e) => {
            this.$message.error(e)
            setTimeout(() => {
              this.loading = false
            }, 1000)
          });
        }
      })
    },
    getUserInfo() {
      userApi.getUserRoleMenu().then((res) => {
          this.loginUser(res.sysUserResDto.username)
          this.loginCheckedMenu(res.sysMenuCheckedDto)
          if(res.sysMenuCheckedDto.length>0){
            this.$router.push({ path: '/'});
          }else{
            this.$router.push({ path: '/' });
          }
      });
    },
  }
}
</script>

<style scoped>
.background-image-login{
  /*background-image: url("../assets/images/login_bg@2x.png");*/
  background: #0356AD;
  /*background-size: 100% 100%;
  height: 100%;
  background-size: cover;
  background-repeat: repeat-y; !* 或 repeat-x, repeat-y *!*/
  /*background-size: cover; !* 根据需要选择 cover, contain, 或自定义大小 *!
  background-size: calc(100% / 2) auto;
  background-size: 50% auto;
  background-size: contain;*/
  height: 100vh;
}
.login-system-title{
  width: 100%;
  height: 110px;
  background: #0356AD;
  backdrop-filter: blur(11px);
  font-weight: 400;
  font-size: 40px;
  color: #FFFFFF;
  line-height: 110px;
  text-align: center;
}
.login-container {
  display: flex;
  width: 100%;
  height: calc(100vh - 200px);
  background: #0356AD;
}

.login-form {
  margin: auto auto auto auto;
  padding: 20px 62px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 300px;
  background: #FFFFFF;
  border-radius: 10px;
}
.title {
  width: 340px;
  padding: 0px 0px 10px 0px;
}
.title h2 {
  position: relative;
  color: rgba(51, 102, 255, 1);
  padding-bottom: 12px;
  border-bottom: #E3E7ED 1px solid;
  width: 340px;
}

.title h2::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 6px;
  width: 140px;
  background-color: rgba(51, 102, 255, 1);
  border-radius: 3px;
}
.login-form .el-form-item{
  width: 340px;
}
.login-system-foot{
  flex-shrink: 0; /* 防止序号部分压缩 */
  width: 100%;
  height: 162px;
  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(11px);
}
.footer{
  text-align: center;
  position: absolute;
  bottom: 0px;
  /* left: 50%; */
  width: 100%;
}
.logo-icon{
  width: 60px;
  position: relative;
  top: 10px;
}
</style>
